<template>
  <div class="mobile-cohort-table__cohort">
    <div class="mobile-cohort-table__separator" />
    <div
      class="mobile-cohort-table__cohort-header"
      v-html="item.cohortName"
    />
    <ElCollapse
      v-model="localActiveDate"
      class="mobile-cohort-table__dates"
      @change="onCollapseChange"
    >
      <div
        v-for="(dateChunk, chunkIndex) in visibleDateChunks"
        :key="`chunk-${chunkIndex}`"
        :ref="chunkIndex === visibleDateChunks.length - 1 ? 'lastChunk' : null"
        class="mobile-cohort-table__date-chunk"
        :class="{ 'mobile-cohort-table__date-chunk_last': chunkIndex === visibleDateChunks.length - 1 }"
      >
        <ElCollapseItem
          v-for="(date, dateIndex) in dateChunk"
          :key="dateIndex + chunkIndex * dateChunkSize"
          class="mobile-cohort-table__date"
          :name="dateIndex + chunkIndex * dateChunkSize"
        >
          <template v-slot:title>
            <div
              class="mobile-cohort-table__date-header"
              v-html="date.date"
            />
          </template>
          <div class="mobile-cohort-table__metrics">
            <div
              v-for="(metric, metricIndex) in date.metrics"
              :key="metricIndex"
              class="mobile-cohort-table__metric"
            >
              <span
                class="mobile-cohort-table__metric-name"
                :class="metric.class"
              >{{ metric.label }}</span>
              <span
                class="mobile-cohort-table__metric-value"
                :class="metric.class"
              >{{ metric.value }}</span>
            </div>
          </div>
        </ElCollapseItem>
      </div>
    </ElCollapse>
  </div>
</template>

<script>
export default {
  name: 'CohortItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  emits: ['update-active-date', 'size-change'],
  data() {
    return {
      localActiveDate: this.item.activeDate || [],
      dateChunkSize: 10,
      visibleDateChunkCount: 2,
      observer: null,
    };
  },
  computed: {
    dateChunks() {
      const chunks = [];
      for (let i = 0; i < this.item.dates.length; i += this.dateChunkSize) {
        chunks.push(this.item.dates.slice(i, i + this.dateChunkSize));
      }
      return chunks;
    },
    visibleDateChunks() {
      return this.dateChunks.slice(0, this.visibleDateChunkCount);
    },
  },
  watch: {
    'item.activeDate': {
      handler(newVal) {
        this.localActiveDate = Array.isArray(newVal) ? [...newVal] : [];
      },
      deep: true,
    },
    visibleDateChunks() {
      this.$nextTick(() => {
        this.setupObserver();
      });
    },
  },
  mounted() {
    this.setupObserver();
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    onCollapseChange(val) {
      this.$emit('update-active-date', {
        index: this.index,
        activeDate: [...val],
      });
      this.$emit('size-change', this.index);
    },
    setupObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && this.visibleDateChunkCount < this.dateChunks.length) {
            this.visibleDateChunkCount += 1;
            this.$emit('size-change', this.index);
          }
        },
        { threshold: 0.3 },
      );
      this.$nextTick(() => {
        const lastChunk = this.$refs.lastChunk;
        if (lastChunk && lastChunk[0]) {
          this.observer.observe(lastChunk[0]);
        }
      });
    },
  },
};
</script>
